import React from 'react';

type BVWidget = 'reviews' | 'inline_rating' | 'rating_summary';
export type BVMode = 'staging' | 'production';

export type BazaarvoiceWidgetProps = {
  attributes: {
    widgetID: BVWidget;
    productID: string;
    seo?: boolean;
  };
};

const BazaarvoiceWidget = function ({
  attributes: { productID, widgetID, seo = false },
  ...props
}: BazaarvoiceWidgetProps) {
  return (
    <div
      data-bv-show={widgetID}
      data-bv-product-id={productID}
      data-bv-seo={seo}
      {...props}
      className="js-track"
    />
  );
};

export default BazaarvoiceWidget;
